import { render, staticRenderFns } from "./EditBlockSlideshowSettingsTabSlides.vue?vue&type=template&id=eef8f2be&scoped=true&"
import script from "./EditBlockSlideshowSettingsTabSlides.vue?vue&type=script&lang=js&"
export * from "./EditBlockSlideshowSettingsTabSlides.vue?vue&type=script&lang=js&"
import style0 from "./EditBlockSlideshowSettingsTabSlides.vue?vue&type=style&index=0&id=eef8f2be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef8f2be",
  null
  
)

export default component.exports